import "../css/connections.css";
import "../css/button.css";
import tablecss from "../css/table.module.css";
import bookclosuretaskscss from "../css/bookclosuretasks.module.css";
import commoncss from "../css/common.module.css";
import buttoncss from "../css/button.module.css";
import { useEffect, useState, useRef } from "react";
import { ReactComponent as CalenderIcon } from "../assets/icons/calender.svg";
import edit_template_sample from "../data/edit_template_sample.json";
import Dropdown from "./../elements/Dropdown";
import {Button} from "./../elements/Button";
import InputGroup from "./../elements/InputGroup";
import Breadcrumb from "./../components/Breadcrumb";

export default function EditGeneralTemplate() {
  const [displayModal, setDisplayModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);

  const breadcrumbItems = [
    {
      label: "Workspace name",
      link: "/myfinV2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Book Closure name",
      link: "/myfinV2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Template Name", link: "", className: "headerLable" },
  ];

  const th_data = [
    { header: "DATE", accessor: "date" },
    { header: "LEDGER CODE", accessor: "ledger_code" },
    { header: "LEDGER NAME", accessor: "ledger_name" },
    { header: "AMOUNT", accessor: "amount" },
    { header: "REMARKS", accessor: "remarks" },
  ];

  const tr_data = edit_template_sample.map((item, i) => ({
    date: item.date,
    ledger_code: item.ledger_code,
    ledger_name: item.ledger_name,
    ledger_amount: item.amount,
    remarks: item.remarks,
  }));

  const handleClose = () => {
    setDisplayModal(false);
  };

  return (
    <>
      <div className="connections-wrapper bgClr1">
        <Breadcrumb
          addCls="bgClr1"
          items={breadcrumbItems}
          headerActions={<></>}
        />
        <div
          className={`info-content ${bookclosuretaskscss.editTemplateContent}`}
        >
          <main>
            <header
              className={`connections-header ${bookclosuretaskscss.editTemplateHeader}`}
            >
              <span
                className="header-title"
                style={{ width: "-webkit-fill-available" }}
              >
                Edit Template
              </span>
                <Button
                  btnColor={buttoncss.secondary}
                  label="Cancel"
                />&ensp;
                <Button
                  btnColor={buttoncss.primary}
                  label="Update"
                />
            </header>
            <div
              class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`}
            >
              <div
                class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}
              >
                <InputGroup
                  inputs={[
                    <>
                      <InputGroup
                        label="Task Name"
                        inputs={[
                          <>
                            <input
                              type="text"
                              onChange={(value) => console.log("value:", value)}
                            />
                          </>,
                        ]}
                      />
                    </>,
                    <>
                      <InputGroup
                        label="Module Name"
                        inputs={[
                          <>
                            <input
                              type="text"
                              onChange={(value) => console.log("value:", value)}
                            />
                          </>,
                        ]}
                      />
                    </>,
                  ]}
                />

                <InputGroup
                  label="Task Description"
                  inputs={[
                    <>
                      <textarea
                        value={""}
                        onChange={(value) => console.log("value:", value)}
                        rows={4}
                      />
                    </>,
                  ]}
                />

                <InputGroup
                  label="Assignee"
                  inputs={[
                    <>
                      <input
                        type="text"
                        onChange={(value) => console.log("value:", value)}
                      />
                    </>,
                  ]}
                />

                <InputGroup
                  inputs={[
                    <>
                      <Dropdown
                        label="Approver"
                        options={[{ label: "", value: "" }]}
                        onSelect={(value) => console.log("Selected:", value)}
                        placeHolder={"Select Approver"}
                      />
                    </>,
                    <>
                      <InputGroup
                        label="Due Date"
                        inputs={[
                          <>
                            <input type="date" />
                            <span className="icon">
                              <CalenderIcon
                                className="vaMiddle"
                                width={20}
                                height={20}
                              />
                            </span>
                          </>,
                        ]}
                      />
                    </>,
                  ]}
                />
                <InputGroup
                  label="Workings & Remarks"
                  inputs={[
                    <>
                      <textarea
                        value={""}
                        onChange={(value) => console.log("value:", value)}
                        rows={6}
                      />
                    </>,
                  ]}
                />
                <InputGroup
                  label="Comments"
                  inputs={[
                    <>
                      <input type="text" placeholder="Add Comment" />
                    </>,
                  ]}
                />
              </div>
              <div
                class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight}`}
              >
                <div className={tablecss.tableContainer}>
                  <table
                    className={`${tablecss.customTable} ${tablecss.taskTable}`}
                  >
                    <thead>
                      <tr>
                        {th_data.map((col, i) => (
                          <th key={i}>{col.header}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tr_data.map((row, i) => (
                        <tr key={i}>
                          {th_data.map((col, j) => (
                            <td key={j}>{row[col.accessor]}</td>
                          ))}
                        </tr>
                      ))}
                      <tr>
                        <td
                          colSpan={th_data.length}
                          style={{ textAlign: "center" }}
                        ></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
